import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormTipoSello from './FormTipoSello';

import getTiposSellos from '../../../../graphql/querys/otros/getTiposSellos.graphql';
import insertTipoSello from '../../../../graphql/mutations/otros/insertTipoSello.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertTipoSello, {
  name: 'insertTipoSello',
  options: {
    refetchQueries: [{ query: getTiposSellos }],
  },
})
class CrearTipoSello extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo_sello: {
        nombre: '',
        valor: 0,
        vigenteDesde: null,
        vigenteHasta: null,
      },
      step: 0,
      loading: false,
    };

    this.guardarTipoSello = this.guardarTipoSello.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarTipoSello(tipo_sello) {
    this.props
      .insertTipoSello({
        variables: {
          tipo_sello,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description: 'Se ha registrado el nuevo tipo de tasa exitosamente',
        });

        this.props.history.push('/admin/otros/tipo_sello');
      })
      .catch(err => {
        console.log('Error en la creacion del tipo sello');
        console.log(err);
        errorService(err, {
          tipo_sello,
        });
        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo de Tasa</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Tipo de Tasa
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTipoSello
              className="formularios"
              onSubmit={this.guardarTipoSello}
              onAnterior={() =>
                this.props.history.push('/admin/otros/tipo_sello')
              }
              datos={this.state.tipo_sello}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearTipoSello);
